module.exports = __webpack_public_path__ + "prototype.2C4TaAnx.svg";